var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"list-group-item",on:{"click":_vm.clickOn}},[_c('div',{staticClass:"radio"},[_c('input',{attrs:{"type":"radio","name":"baselayersradio"},domProps:{"checked":_vm.visible}}),_c('label',{staticClass:"text-left",attrs:{"for":"radio1"}},[_vm._v(_vm._s(_vm.label))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }